import { Rate as AntdRate, RateProps } from 'antd';
import cn from 'classnames';
import styles from './Rate.module.scss';

export const Rate = (props: RateProps) => {
  return <AntdRate {...props} className={cn(styles.rate, props.className)} />;
};
